import { Injectable } from "@angular/core";
import { StatusBar, Style } from "@capacitor/status-bar";

@Injectable({
    providedIn: "root",
})
export class ThemeService {
    async initialize() {
        await this.setTheme(this.getCurrentTheme());

        // Écoute les changements du mode dark/light
        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
        mediaQuery.addEventListener("change", async (event) => {
            const newTheme = event.matches ? "dark" : "light";

            await this.setTheme(newTheme);
        });
    }

    private getCurrentTheme(): string {
        return window.matchMedia("(prefers-color-scheme: dark)").matches
               ? "dark"
               : "light";
    }

    private async setTheme(currentTheme: any) {
        if (currentTheme === "dark") {
            await StatusBar.setStyle({ style: Style.Dark });
        } else {
            await StatusBar.setStyle({ style: Style.Dark });
        }
    }
}
